import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ProcGridState {
  rowData: any[];
  filteredRowData: any[];
  checkedRowUpdateAt: string;
}

const initialState: ProcGridState = {
  rowData: [],
  filteredRowData: [],
  checkedRowUpdateAt: (new Date()).toISOString(),
};

export const procGridSlice = createSlice({
  name: 'procGrid',
  initialState,
  reducers: {
    setRowData: (state, action: PayloadAction<any[]>) => {
      state.rowData = action.payload;
    },
    setFilteredRowData: (state, action: PayloadAction<any[]>) => {
      state.filteredRowData = action.payload;
    },
    setCheckedRowUpdateAt: (state, action: PayloadAction<string>) => {
      state.checkedRowUpdateAt = action.payload;
    },
  },
});

export const { setRowData, setFilteredRowData, setCheckedRowUpdateAt } = procGridSlice.actions;

export default procGridSlice.reducer;
